import type { SettingValueMap } from 'portlet/models';

import type { QueryReplacer } from '.';

export const ConditionLimitReplacer: QueryReplacer = {
    regex: /\{conditionLimit\}/,
    replace: (statement, _metadata, _filterValues, regexMatches, settings) => {
        const value = getDatabricksConditionLimitValue(settings);

        return regexMatches.reduce(
            (pre, cur) => pre.replace(cur.exact, value.toString()),
            statement,
        );
    },
};

export function getDatabricksConditionLimitValue(settings: Partial<SettingValueMap>): string {
    return settings.DATABRICKS_CONDITION && settings.DATABRICKS_CONDITION.limit
        ? settings.DATABRICKS_CONDITION.limit.toString()
        : '';
}
